import * as fromActions from '../actions/blocks.action'
import { Reducer } from 'redux'

export const initialState: any = {
  list: [],
  edit: [],
  loading: true,
  evaluation: [],
}

export const reducer: Reducer<any> = (
  state: any = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.GET_LESSON_BLOCKS_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_LESSON_BLOCKS_LIST_SUCCESS:
      return {
        ...state,
        list: payload,
        loading: false,
      }
    case fromActions.SURVEY_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.RICHTEXT_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.TASK_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.MULTIMEDIA_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EVALUATION_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EDIT_RICHTEXT_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EDIT_TASK_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EDIT_MULTIMEDIA_BLOCK:
      return {
        ...state,
        loading: true,
      }

    case fromActions.BLOCK_CREATE_SUCCESS:
      return {
        ...state,
        edit: payload,
      }
    case fromActions.EDIT_BLOCK:
      return {
        ...state,
        edit: payload,
      }
    case fromActions.CLEAR_EDIT:
      return {
        ...state,
        edit: [],
      }
    case fromActions.DESTROY_SURVEY_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.DESTROY_RICHTEXT_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.DESTROY_TASK_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.DESTROY_MULTIMEDIA_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.DESTROY_EVALUATION_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_EVALUATION_DATA:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_EVALUATION_DATA_SUCCESS:
      return {
        ...state,
        evaluation: payload,
        loading: false,
      }
    case fromActions.SCORM_BLOCK_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.BLOCK_LOADING: {
      return {
        ...state,
        loading: payload,
      }
    }
    case fromActions.EDIT_SCORM_BLOCK:
      return {
        ...state,
        loading: true,
      }
    case fromActions.DESTROY_SCORM_BLOCK:
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}
